import LoginPage from 'views/pages/LoginPage'
import LogoutPage from 'views/pages/LogoutPage'
import Register from 'views/pages/Register'
import ForgotPassword from 'views/pages/ForgotPassword'

const authRoutes = [
  {
    path: '/register',
    name: 'Register',
    icon: 'nc-icon nc-key-25',
    component: Register,
    layout: '/auth',
  },
  {
    path: '/login',
    name: 'Log In',
    icon: 'nc-icon nc-key-25',
    component: LoginPage,
    layout: '/auth',
  },
  {
    path: '/logout',
    name: 'Log Out',
    icon: 'fa fa-sign-out',
    component: LogoutPage,
    layout: '/auth',
  },
  {
    path: '/forgotpassword',
    name: 'Forgot Password',
    icon: 'nc-icon nc-key-25',
    component: ForgotPassword,
    layout: '/auth',
  },
]

export default authRoutes
